import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  fetchActivityBoardSuccess,
  fetchActivityBoardFailure,
} from "./actions";
import { FETCH_ACTIVITY_BOARD } from "./constants";

export function* fetchActivityBoardSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, from, to } = payload || {};
  const params = [];
  if (from) params.push(`from=${from}`);
  if (to) params.push(`to=${to}`);
  const query = params.length ? `?${params.join("&")}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${id}/activity-board${query}`,
    );
    // apiResponse wraps the body as { status, data: {...}, message }.
    const body = data?.data ?? data ?? {};
    yield put(
      fetchActivityBoardSuccess({
        stats: body.stats ?? null,
        programme: body.programme ?? [],
        quietList: body.quiet_list ?? [],
        excused: body.excused ?? [],
        away: body.away ?? [],
        nearbyPlaces: body.nearby_places ?? [],
        weather: body.weather ?? [],
        whatWorks: body.what_works ?? [],
        range: body.range ?? null,
        location: body.location ?? null,
        generatedAt: body.generated_at ?? null,
      }),
    );
  } catch (e) {
    yield put(fetchActivityBoardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while loading the activity board."));
  }
}

export function* fetchActivityBoardFlow() {
  yield takeLatest(FETCH_ACTIVITY_BOARD, fetchActivityBoardSaga);
}

export default function* ActivityBoardSaga() {
  yield all([fetchActivityBoardFlow()]);
}
